// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './dex-vaults-api';

export const useConvert: typeof hookExports.useConvert = hookExports.useConvert;
export const useGetVaultBalance: typeof hookExports.useGetVaultBalance =
  hookExports.useGetVaultBalance;
export const useLazyGetVaultBalance: typeof hookExports.useLazyGetVaultBalance =
  hookExports.useLazyGetVaultBalance;
export const useGetVaultDetails: typeof hookExports.useGetVaultDetails =
  hookExports.useGetVaultDetails;
export const useLazyGetVaultDetails: typeof hookExports.useLazyGetVaultDetails =
  hookExports.useLazyGetVaultDetails;
export const useGetVaultSource: typeof hookExports.useGetVaultSource =
  hookExports.useGetVaultSource;
export const useLazyGetVaultSource: typeof hookExports.useLazyGetVaultSource =
  hookExports.useLazyGetVaultSource;
export const useToRaw: typeof hookExports.useToRaw = hookExports.useToRaw;
export const useLazyToRaw: typeof hookExports.useLazyToRaw = hookExports.useLazyToRaw;
export const useWithdraw: typeof hookExports.useWithdraw = hookExports.useWithdraw;
export const useRefreshVault: typeof hookExports.useRefreshVault = hookExports.useRefreshVault;
export const useListVaults: typeof hookExports.useListVaults = hookExports.useListVaults;
export const useLazyListVaults: typeof hookExports.useLazyListVaults =
  hookExports.useLazyListVaults;
export const useAddVault: typeof hookExports.useAddVault = hookExports.useAddVault;
export const useUpdateVault: typeof hookExports.useUpdateVault = hookExports.useUpdateVault;
export const useDeleteVault: typeof hookExports.useDeleteVault = hookExports.useDeleteVault;
export const useUpdateVaultStatus: typeof hookExports.useUpdateVaultStatus =
  hookExports.useUpdateVaultStatus;
export const useListVaultStats: typeof hookExports.useListVaultStats =
  hookExports.useListVaultStats;
export const useLazyListVaultStats: typeof hookExports.useLazyListVaultStats =
  hookExports.useLazyListVaultStats;
export const useListExecutors: typeof hookExports.useListExecutors = hookExports.useListExecutors;
export const useLazyListExecutors: typeof hookExports.useLazyListExecutors =
  hookExports.useLazyListExecutors;
